import { faFileDownload } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Breadcrumb from "components/Common/Breadcrumb2"
import useInterval from "hooks/useInterval"
import useIsDarkTheme from "hooks/useIsDarkTheme"
import jwt from "jsonwebtoken"
import moment from "moment"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { Link } from "react-router-dom/cjs/react-router-dom"
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  Row,
  Spinner,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import {
  downloadFile,
  downloadFileS3,
  getExportNotifications,
  getTemplates,
} from "services/exports/calls"
import SimpleBar from "simplebar-react"
import "simplebar-react/dist/simplebar.min.css"
import { mapStatus, mapTipo, tiposArquivo } from "./constants"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import classNames from "classnames"

const Exportação = props => {
  moment.locale("pt-br")
  document.title = "Exportação | Sensetek"

  const [files, setFiles] = useState([])
  const [filesAux, setFilesAux] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [canDownload, setCanDownload] = useState(true)
  const [progress, setProgress] = useState(0)
  const [count, setCount] = useState(0)
  const [createdCount, setCreatedCount] = useState(0)
  const [finishedCount, setFinishedCount] = useState(0)
  const [typesCount, setTypesCount] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [jsonFilter, setJsonFilter] = useState([])
  const [filterType, setFilterType] = useState(null)
  const [baseType, setBaseType] = useState("")
  const [title, setTitle] = useState("")

  const [interval, setInterval] = useState(15000)
  const [refreshDropDown, setRefreshDropDown] = useState(false)

  const [templates, setTemplates] = useState()

  const paginationLimit = 10

  const initPageOptions = {
    sizePerPage: paginationLimit,
    totalSize: filesAux?.length,
    custom: true,
    showTotal: true,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    prePageText: "Anterior",
    nextPageText: "Próximo",
    paginationTotalRenderer: () => {
      return (
        <div className="d-inline">
          <span className="react-bootstrap-table-pagination-total">
            Registros Retornados: {filesAux?.length}
          </span>
        </div>
      )
    },
  }
  const [pageOptions, setPageOptions] = useState(initPageOptions)

  const defaultSorted = [
    {
      dataField: "shippingTrackerCode",
      order: "desc",
    },
  ]

  const selectRow = {
    mode: "checkbox",
    hideSelectColumn: true,
  }

  const columns = [
    {
      dataField: "filename",
      text: "Nome",
      sort: false,
      formatter: (cellContent, row) => cellContent.replace(/^.+\//, ""),
    },
    {
      dataField: "templateName",
      isDummyField: true,
      text: "Template",
      headerAlign: "center",
      sort: false,
      align: "center",
      formatter: (cellContent, row) => (
        <>
          {templates?.filter(t => t?.alias === row?.baseType).length > 0
            ? templates?.filter(t => t?.alias === row?.baseType)[0].templateName
            : row?.baseType}
        </>
      ),
    },
    {
      dataField: "createdAt",
      text: "Criação",
      headerAlign: "center",
      sort: false,
      align: "center",
      formatter: (cellContent, row) =>
        cellContent ? (
          <>{moment(row.createdAt).format("DD/MM/YYYY  HH:mm")}</>
        ) : (
          ""
        ),
    },
    {
      dataField: "generatedAt",
      text: "Fim",
      headerAlign: "center",
      sort: false,
      align: "center",
      formatter: (cellContent, row) =>
        cellContent ? (
          <>{moment(row.generatedAt).format("DD/MM/YYYY  HH:mm")}</>
        ) : (
          ""
        ),
    },
    {
      dataField: "filtro",
      isDummyField: true,
      text: "Filtro",
      headerAlign: "center",
      align: "center",
      formatter: (cellContent, row) => (
        <ul className="list-unstyled mb-0">
          <li data-bs-toggle="tooltip" data-bs-placement="top">
            <Link
              to="#"
              className={`btn btn-sm btn-${darkTheme ? "soft-" : ""}primary`}
              onClick={() => {
                setJsonFilter(row.filters)
                setShowModal(true)
              }}
            >
              <i
                className="mdi mdi-eye-outline"
                id={`viewtooltip-${row.id}`}
              ></i>
            </Link>
          </li>
          <UncontrolledTooltip placement="top" target={`viewtooltip-${row.id}`}>
            {props.t("Visualizar")}
          </UncontrolledTooltip>
        </ul>
      ),
    },
    {
      dataField: "status",
      isDummyField: true,
      text: "Status",
      headerAlign: "center",
      sort: false,
      align: "center",
      formatter: (cellContent, row) => <>{mapStatus[row.status]}</>,
    },
    {
      dataField: "placeInQueue",
      isDummyField: true,
      text: "Posição",
      headerAlign: "center",
      align: "center",
      formatter: (cellContent, row) => (
        <>
          {row?.placeInQueue ? (
            <span
              className={`badge bg-${
                row?.placeInQueue > 10
                  ? "danger"
                  : row?.placeInQueue <= 10 && row?.placeInQueue > 5
                  ? "warning"
                  : "success"
              } rounded-pill text-center`}
            >
              {row?.placeInQueue}º
            </span>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      dataField: "actions",
      isDummyField: true,
      text: "Ações",
      headerAlign: "center",
      align: "center",
      formatter: (cellContent, row) => (
        <>
          {row.status == "COMPLETED" && (
            <button
              disabled={!canDownload}
              className="btn btn-link"
              onClick={() =>
                // download({ filename: row.filename })
                downloadFileFromS3_V2(row.id, row.filename)
              }
            >
              [ <FontAwesomeIcon icon={faFileDownload} /> Baixar ]
            </button>
          )}
        </>
      ),
    },
  ]

  const intervalRef = useInterval(() => {
    getFilesList()
    setIsLoading(false)
  }, interval)

  const darkTheme = useIsDarkTheme()

  const downloadFileFromS3_V2 = async (fileId, filename) => {
    const { url } = await downloadFileS3(fileId)
    const link = document.createElement("a")
    link.href = url
    link.setAttribute("download", filename.replace(/^.+\//, ""))
    document.body.appendChild(link)
    link.click()
    return
  }

  const getFilesList = async () => {
    setIsLoading(true)
    try {
      let userId
      if (localStorage.getItem("token")) {
        userId = jwt.decode(localStorage.getItem("token"))?.userId
      } else {
        userId = -1
      }
      const res = await getExportNotifications(userId)
      const { payload } = await getTemplates()
      setTemplates(payload)
      setFiles(res)
      setFilesAux(res)
      setCount(res.length)
      setCreatedCount(
        res.filter(obj => {
          return obj.status === "CREATED"
        }).length
      )
      setFinishedCount(
        res.filter(obj => {
          return obj.status === "COMPLETED"
        }).length
      )
      setTypesCount(
        payload.map(item => {
          return {
            type: item,
            count: res.filter(obj => {
              return obj.baseType === item?.alias
            }).length,
          }
        })
      )
      filterFiles(res)
    } catch (err) {
      console.log(err)
    }
  }

  const filterFiles = files => {
    if (tiposArquivo.includes(filterType)) {
      filterFilesByType(filterType, files)
    } else if ((filterType === "CREATED") | (filterType === "COMPLETED")) {
      filterFilesByStatus(filterType, files)
    } else {
      setFilesAux(files)
    }
  }

  useEffect(() => {
    try {
      getFilesList()
    } catch (error) {
    } finally {
      setIsLoading(false)
    }
  }, [])

  const filterFilesByType = (type, files) => {
    setFilterType(type)
    setFilesAux(
      files.filter(obj => {
        return obj.baseType === type
      })
    )
  }

  const filterFilesByStatus = (status, files) => {
    setFilterType(status)
    setFilesAux(
      files.filter(obj => {
        return obj.status === status
      })
    )
  }

  const stringifyParse = text => {
    try {
      return JSON.stringify(JSON.parse(text), null, 2)
    } catch (error) {
      return "Erro ao tentar pegar o filtro."
    }
  }

  const handleNextPage =
    ({ page, onPageChange }) =>
    () => {
      onPageChange(page + 1)
    }

  const handlePrevPage =
    ({ page, onPageChange }) =>
    () => {
      onPageChange(page - 1)
    }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Exportação")}
            breadcrumbItems={[{ title: props.t("Arquivos"), path: "#" }]}
          />
          <Row>
            <Col sm={2}>
              <Card>
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  Informações
                </CardHeader>
                <CardBody>
                  <SimpleBar style={{ overflowY: "hidden" }}>
                    <Table className="table align-middle table-nowrap table-hover mb-0 table-striped">
                      <tbody>
                        <tr
                          className={baseType === "" ? "table-primary" : ""}
                          onClick={() => {
                            setFilesAux(files)
                            setFilterType(null, files)
                            setBaseType("")
                            setTitle(" (Total)")
                          }}
                        >
                          <td>Total:</td>
                          <td>{count}</td>
                        </tr>
                        <tr
                          className={
                            baseType === "CREATED" ? "table-primary" : ""
                          }
                          onClick={() => {
                            filterFilesByStatus("CREATED", files)
                            setBaseType("CREATED")
                            setTitle(" (Criados)")
                          }}
                        >
                          <td>Arquivos Criados:</td>
                          <td>{createdCount}</td>
                        </tr>
                        <tr
                          className={
                            baseType === "COMPLETED" ? "table-primary" : ""
                          }
                          onClick={() => {
                            filterFilesByStatus("COMPLETED", files)
                            setBaseType("COMPLETED")
                            setTitle(" (Finalizdos)")
                          }}
                        >
                          <td>Arquivos Finalizados:</td>
                          <td>{finishedCount}</td>
                        </tr>
                        {typesCount?.map((item, index) => {
                          return (
                            <tr
                              className={
                                baseType === item.type?.alias
                                  ? "table-primary"
                                  : ""
                              }
                              key={index}
                              onClick={() => {
                                setTitle(` (${item.type?.templateName})`)
                                filterFilesByType(item.type?.alias, files)
                                setBaseType(item.type?.alias)
                              }}
                            >
                              <td>{item.type?.templateName}:</td>
                              <td>{item.count}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </Table>
                  </SimpleBar>
                </CardBody>
              </Card>
            </Col>
            <Col sm={10}>
              <Card>
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  <Row className="hstack">
                    <Col>
                      Arquivos{title}: {filesAux?.length}
                    </Col>
                    <Col>
                      <Dropdown
                        isOpen={refreshDropDown}
                        toggle={() => setRefreshDropDown(!refreshDropDown)}
                        className="mt-4 mt-sm-0 float-end"
                      >
                        <DropdownToggle className="btn btn-secondary" caret>
                          <i className="bx bx-alarm d-block"></i>
                          Refresh{" "}
                          {interval ? `${interval / 1000}s` : "desativado"}
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem
                            onClick={() => {
                              setInterval(null)
                              setRefreshDropDown(false)
                            }}
                          >
                            Desativar
                          </DropdownItem>
                          <DropdownItem
                            onClick={() => {
                              setInterval(5000)
                              setRefreshDropDown(false)
                            }}
                          >
                            5s
                          </DropdownItem>
                          <DropdownItem
                            onClick={() => {
                              setInterval(10000)
                              setRefreshDropDown(false)
                            }}
                          >
                            10s
                          </DropdownItem>
                          <DropdownItem
                            onClick={() => {
                              setInterval(15000)
                              setRefreshDropDown(false)
                            }}
                          >
                            15s
                          </DropdownItem>
                          <DropdownItem
                            onClick={() => {
                              setInterval(30000)
                              setRefreshDropDown(false)
                            }}
                          >
                            30s
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  {!isLoading &&
                    (filesAux.length > 0 ? (
                      <PaginationProvider
                        pagination={paginationFactory(pageOptions)}
                      >
                        {({ paginationProps, paginationTableProps }) => (
                          <ToolkitProvider
                            keyField="id"
                            columns={columns}
                            columnToggle
                            data={filesAux}
                            search
                          >
                            {toolkitProps => (
                              <React.Fragment>
                                <Row>
                                  <Col xl="12">
                                    <BootstrapTable
                                      keyField={"id"}
                                      bordered={true}
                                      striped={true}
                                      condensed
                                      defaultSorted={defaultSorted}
                                      selectRow={selectRow}
                                      classes={
                                        "table table-sm align-middle table-nowrap"
                                      }
                                      headerWrapperClasses={"thead-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                    />
                                    {filesAux?.length > paginationLimit && (
                                      <ul className="pagination react-bootstrap-table-page-btns-ul">
                                        <li
                                          className={classNames({
                                            "page-item": true,
                                            active: paginationProps.page !== 1,
                                          })}
                                        >
                                          <a
                                            className="page-link"
                                            onClick={handlePrevPage(
                                              paginationProps
                                            )}
                                            disabled={
                                              paginationProps.page === 1
                                            }
                                          >
                                            Anterior
                                          </a>
                                        </li>
                                        <li className="page-item">
                                          <a className="page-link" disabled>{`${
                                            paginationProps.page
                                          }/${Math.ceil(
                                            filesAux?.length /
                                              paginationProps.sizePerPage
                                          )}`}</a>
                                        </li>
                                        <li
                                          className={classNames({
                                            "page-item": true,
                                            active:
                                              paginationProps.page !==
                                              Math.ceil(
                                                filesAux?.length /
                                                  paginationProps.sizePerPage
                                              ),
                                          })}
                                        >
                                          <a
                                            className="page-link"
                                            onClick={handleNextPage(
                                              paginationProps
                                            )}
                                            disabled={
                                              paginationProps.page ===
                                              Math.ceil(
                                                filesAux?.length /
                                                  paginationProps.sizePerPage
                                              )
                                            }
                                          >
                                            Próximo
                                          </a>
                                        </li>
                                      </ul>
                                    )}
                                  </Col>
                                </Row>
                              </React.Fragment>
                            )}
                          </ToolkitProvider>
                        )}
                      </PaginationProvider>
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        <h5>Nenhum dado foi encontrado.</h5>
                      </div>
                    ))}
                  {isLoading && (
                    <div
                      className="accordion-body"
                      style={{ textAlign: "center" }}
                    >
                      <Spinner className="ms-2" color="primary" />
                    </div>
                  )}
                  {/* </SimpleBar> */}
                  {/* </div> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>Filtro</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setShowModal(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div>
            <pre>{stringifyParse(jsonFilter)}</pre>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setShowModal(false)
            }}
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {props.t("Fechar")}
          </button>
        </div>
      </Modal>
    </React.Fragment>
  )
}

Exportação.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Exportação)
